import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Page } from "@/uiKit/atoms/page/Page.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageHeader } from "@/uiKit/atoms/page/PageHeader.tsx";
import { PractitionerBillingCard } from "@/uiKit/organisms/PractitionerBillingCard.tsx";

export const PractitionerBillingPage: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Page id="practitioner-billing-page" className={styles.container}>
      <PageHeader title={t("pages.practitionerBilling.title")} className={styles.header} />
      <PageContent className={styles.content}>
        <PractitionerBillingCard />
      </PageContent>
    </Page>
  );
};

const makeStyles = () => ({
  container: css({}),
  header: css({}),
  content: css({}),
});
